export enum TransactionTypeView {
  DEPOSIT = 'Deposit',
  INCREASE = 'Increase',
  INTEREST = 'Interest',
  WITHDRAWAL = 'Withdrawal',
  LOAN = 'Loan',
  COLLATERAL = 'Collateral',
  REDEMPTION = 'Redemption',
  REPAYMENT = 'Repayment',
  TOP_UP = 'Top up',
  EXCHANGE = 'Exchange',
  DEFAULT = 'Type',
  LOAN_EVENT = 'Loan event',
  MONTHLY_INTEREST = 'Monthly interest',
  HOURLY_INTEREST = 'hourly_interest',
}

export enum TransactionStatusView {
  SUCCESS = 'Success',
  CONFIRMING = 'Confirming',
  PENDING = 'Pending',
  REJECTED = 'Rejected',
  PROCESSING = 'Processing',
  REFUNDED = 'Refunded',
}
